module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "loi"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "px"
    }
  }), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxi"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/Text/Hardesty0006#toc"
    }
  }, [_vm._v("Figures and Tables")])]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahloi01"
    }
  }, [_vm._v("Figures")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Hardesty0010#Fig1"
    }
  }, [_vm._v("1. “A Female Negro Slave, with a Weight chain”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Hardesty0010#Fig2"
    }
  }, [_vm._v("2. “Joanna”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Hardesty0010#Fig3"
    }
  }, [_vm._v("3. “A Coromantyn Free Negro, or Ranger, armed”")])]), _vm._v(" "), _c('h2', {
    staticClass: "ah",
    attrs: {
      "id": "ahloi02"
    }
  }, [_vm._v("Tables")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Hardesty0011#Table1"
    }
  }, [_vm._v("1. Boston Slave Ownership by Occupation in Probate Inventories, 1700–1775")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Hardesty0011#Table2"
    }
  }, [_vm._v("2. Runaway Servant Advertisements in Boston, 1700–1750")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Hardesty0012#Table3"
    }
  }, [_vm._v("3. Black Marriages in Boston, 1700–1775")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de542b34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Hardesty-0007.vue
// module id = 72
// module chunks = 0